<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Receipt

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body padding-top-0px">
        <div class="row border-top border-bottom margin-top-5px bk-color-light">
          <div class="col-md-3">
            <div class="row  nav-link-hand">
              <div class="col-md-2 padding-left-0px margin-top-5px">
                <img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">



              </div>
              <div class="col-md-10 margin-top-5px padding-right-0px ">
                <div class="row row-height-17px">
                  <div class="col-md-12">
                    <label class="margin-bottom-0px font-size-14 font-weight-bold">Ramya santhosh</label>
                  </div>
                </div>
                <div class="row row-height-17px">
                  <div class="col-md-12">
                    <label class="margin-bottom-0px font-size-12px">Bill Date:10-OCt-2019</label>
                  </div>
                </div>


              </div>

            </div>
          </div>
          <div class="col-md-3  text-align-center">
            <div><label class=" font-weight-bold label-color-consultant margin-bottom-0px">Charge Entry No</label></div>
            <div><label class="margin-bottom-0px">80335</label></div>
          </div>
          <div class="col-md-3  text-align-center">
            <div><label class="label-color-consultant  font-weight-bold margin-bottom-0px">Total Charge Entry</label></div>
            <div><label class="margin-bottom-0px">3340</label></div>
          </div>
          <div class="col-md-3 text-align-center">
            <div><label class=" font-weight-bold label-color-consultant margin-bottom-0px">Total payable</label></div>
            <div><label class="margin-bottom-0px">0.00</label></div>
          </div>

        </div>




        <div class="row">
          <div class="col-md-12 padding-right-0px padding-left-0px">
            <div class="table-component margin-bottom-5px">
              <div class="table-responsive">


                <table class="table table-striped">

                  <thead class="">
                    <tr>
                      <th class="min-width-0px background-primary"></th>

                      <th class="background-primary">Payment Mode</th>
                      <th class="background-primary">Amount</th>
                      <th class="background-primary">Charges</th>
                      <th class="background-primary">Ref.No</th>
                      <th class="background-primary">Details</th>
                    </tr>
                  </thead>
                  <tbody class="table-body">

                    <tr>
                      <td class="td-padding ">

                        <input type="checkbox">


                      </td>

                      <td class="padding-top-4px padding-bottom-4px">
                        Cash
                      </td>
                      <td class="padding-top-4px padding-bottom-4px">
                        <input type="number" class="form-control"
                               min="1" max="10" />
                      </td>
                      <td class="padding-top-4px padding-bottom-4px">
                        &#64; 0.00 %=
                      </td>
                      <td class="padding-top-4px padding-bottom-4px">
                        <input type="number" class="form-control"
                               min="1" max="10" />
                      </td>

                      <td class="padding-top-4px padding-bottom-4px">
                        <input type="number" class="form-control"
                               min="1" max="10" />

                      </td>



                    </tr>
                    <tr>
                      <td class="td-padding ">

                        <input type="checkbox">


                      </td>

                      <td class="padding-top-4px padding-bottom-4px">
                        Card
                      </td>
                      <td class="padding-top-4px padding-bottom-4px">
                        <input type="number" class="form-control"
                               min="1" max="10" />
                      </td>
                      <td class="padding-top-4px padding-bottom-4px">
                        &#64; 0.00 %=
                      </td>
                      <td class="padding-top-4px padding-bottom-4px">
                        <input type="number" class="form-control"
                               min="1" max="10" />
                      </td>

                      <td class="padding-top-4px padding-bottom-4px">
                        <input type="number" class="form-control"
                               min="1" max="10" />

                      </td>



                    </tr>
                    <tr>
                      <td class="td-padding ">

                        <input type="checkbox">


                      </td>

                      <td class="padding-top-4px padding-bottom-4px">
                        Cheque
                      </td>
                      <td class="padding-top-4px padding-bottom-4px">
                        <input type="number" class="form-control"
                               min="1" max="10" />
                      </td>
                      <td class="padding-top-4px padding-bottom-4px">
                        &#64; 0.00 %=
                      </td>
                      <td class="padding-top-4px padding-bottom-4px">
                        <input type="number" class="form-control"
                               min="1" max="10" />
                      </td>

                      <td class="padding-top-4px padding-bottom-4px">
                        <input type="number" class="form-control"
                               min="1" max="10" />

                      </td>



                    </tr>
                    <tr>
                      <td class="td-padding ">

                        <input type="checkbox">


                      </td>

                      <td class="padding-top-4px padding-bottom-4px">
                        Demand Draft
                      </td>
                      <td class="padding-top-4px padding-bottom-4px">
                        <input type="number" class="form-control"
                               min="1" max="10" />
                      </td>
                      <td class="padding-top-4px padding-bottom-4px">
                        &#64; 0.00 %=
                      </td>
                      <td class="padding-top-4px padding-bottom-4px">
                        <input type="number" class="form-control"
                               min="1" max="10" />
                      </td>

                      <td class="padding-top-4px padding-bottom-4px">
                        <input type="number" class="form-control"
                               min="1" max="10" />

                      </td>



                    </tr>
                    <tr>
                      <td class="td-padding ">

                        <input type="checkbox">


                      </td>

                      <td class="padding-top-4px padding-bottom-4px">
                        Paytm
                      </td>
                      <td class="padding-top-4px padding-bottom-4px">
                        <input type="number" class="form-control"
                               min="1" max="10" />
                      </td>
                      <td class="padding-top-4px padding-bottom-4px">
                        &#64; 0.00 %=
                      </td>
                      <td class="padding-top-4px padding-bottom-4px">
                        <input type="number" class="form-control"
                               min="1" max="10" />
                      </td>

                      <td class="padding-top-4px padding-bottom-4px">
                        <input type="number" class="form-control"
                               min="1" max="10" />

                      </td>



                    </tr>
                  </tbody>

                </table>

              </div>
            </div>
          </div>





        </div>

        <div class="row background-bill-row">
          <div class="col-md-4">
            <div class="row margin-top-10">
              <div class="col-md-7 padding-right-0px text-align-center">
                <label class="margin-bottom-0px font-size-13px">Advance Collected:</label>
              </div>
              <div class="col-md-2 padding-left-0px">
                <label class="margin-bottom-0px font-size-13px">0.00</label>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row margin-top-10">
              <div class="col-md-8 padding-right-0px">
                <label class="margin-bottom-0px font-size-13px">Use Advance Settlement:</label>
              </div>
              <div class="col-md-2 padding-left-0px">
                <input type="checkbox" class="width-14px height-27px">
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row margin-top-10">
              <div class="col-md-8 padding-right-0px">
                <label class="margin-bottom-0px font-size-13px">Bal after Adv Settlement:</label>
              </div>
              <div class="col-md-3 padding-left-0px">
                <label class="margin-bottom-0px font-size-13px">0.00</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row ">
          <div class="col-md-4">
            <div class="row margin-top-10">
              <div class="col-md-8 padding-right-0px text-align-center">
                <label class="margin-bottom-0px font-size-13px">Company Wise Payable:</label>
              </div>
              <div class="col-md-2 padding-left-0px">
                <label class="margin-bottom-0px font-size-13px">0.00</label>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <!--<div class="row margin-top-10">
              <div class="col-md-8 padding-right-0px">
                <label class="margin-bottom-0px font-size-13px">Use Advance Settlement:</label>
              </div>
              <div class="col-md-2 padding-left-0px">
                <input type="checkbox" class="width-14px height-27px">
              </div>
            </div>-->
          </div>
          <div class="col-md-4">
            <div class="row margin-top-10">
              <div class="col-md-8 padding-right-0px">
                <label class="margin-bottom-0px font-size-13px">Card Amount Payable:</label>
              </div>
              <div class="col-md-3 padding-left-0px">
                <label class="margin-bottom-0px font-size-13px">0.00</label>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
        <button type="submit" *ngIf='!isRequesting' (click)="gotoservice()" class="btn actions-btn-prime margin-right-auto">Save</button>
      </div>
  </div>
</div>
  </div>
